import { render, staticRenderFns } from "./dashboardsales.vue?vue&type=template&id=68d59d7d"
import script from "./dashboardsales.vue?vue&type=script&lang=js"
export * from "./dashboardsales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports